import React, { useContext, useEffect, useRef, useState } from "react";
import {
  CONTEXT_TYPES,
  HTTP_RESPONSE_CODES,
} from "../../../../globals/globals";
import "./PartList.css";
import { attachContextmenuInfo } from "../../../../services/contextMenuService";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import useDialog from "../../../../hooks/useDialog";
import Item from "../../../../components/Lists/Item";
import { PartDetailsDialog } from "./PartDetailsDialog";
import { getPartDetails } from "../../Services/PartsService";
import { Tag } from "../../../../components/Tags/Tag";
import { InventoryManagementContext } from "../../context/InventoryManagementContext";
import { Expandable } from "../../../../components/Expandable/Expandable";
import { PartDetails } from "./PartDetails";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Sorting } from "../../../../components/Lists/Sorting";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { useDispatch } from "react-redux";
import { clearActiveTab } from "../../../../redux/features/TabsManager/tabSlice";
import { DialogContext } from "../../../../contexts/DialogContext";
import { InventoryManagementIssue } from "../InventoryManagementComponent/InventoryManagementIssue/InventoryManagementIssue";
import { environment } from "../../../../environments/environment";
import { InventoryManagementReturn } from "../InventoryManagementComponent/InventoryManagementReturn/InventoryManagementReturn";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";
const icons = {
  part: "icon-part",
  consumable: "icon-consumable",
};

const PartImage = ({ item }) => {
  const { successMsg, infoMsg } = useSnackBar();

  const imageActions = {
    image1: {
      label: "Action 1",
      icon: "icon-part",
      callback: () => successMsg("Success"),
    },
    image2: {
      label: "Action 2",
      icon: "icon-settings",
      callback: () => infoMsg("Lorem ipsum"),
    },
  };

  return (
    <div
      className={`image-container ${item.type}`}
      onContextMenu={(event) =>
        attachContextmenuInfo({
          event,
          type: CONTEXT_TYPES.PART_IMAGE,
          data: "...",
          options: imageActions,
        })
      }
    >
      <i className={icons[item.type]}></i>
    </div>
  );
};

export const PartList = () => {
  const {
    partList,
    requestNextPage,
    setLoadingParts,
    loadingParts,
    navigateBatch,
    setNavigateBatch,
    setSortingOrder,
    tabIndex,
    setUpdateFromPartIssue,
  } = useContext(InventoryManagementContext);
  const navigate = useNavigate();
  const { successMsg, warningMsg } = useSnackBar();
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [openStates, setOpenStates] = useState({});
  const [headerProperties, setHeaderProperties] = useState({});
  const [formattedItems, setFormattedItems] = useState([]);
  const listRef = useRef(null);
  const itemMapper = (item) => {
    const key = "inventoryLocation";
    const value = item.aircraft_id
      ? `Aircraft - ${item.aircraft_name ?? "--"}`
      : item.location_code && item.location_name
      ? `${item.location_code} - ${item.location_name}`
      : "--";

    if (!item.serial_number) {
      return {
        id: item.id,
        partId: item.part_id,
        PN: item.part_number || "--",
        ...(tabIndex !== 2 && { SN: item.serial_number || "--" }),
        companyName: item.company_name || "--",
        Batch: item.batch_name || "N/A",
        QTY: (item.quantity || "0") + " " + item.uom_abrevation,
        [key]: value, // Propiedad dinámica
        "PN Description": item.part_description,
        status: item.status,
        type: item.type,
        uomName: item.uom_name,
        internalBatch: item.internal_batch,
        location_name: item.location_name,
        location_code: item.location_code,
        aircraft_name: item.aircraft_name,
        serializedPartId: item.serialized_part,
        aircraft_id: item.aircraft_id,
        orginalInfo: item,
        isPartialIssued: item.isPartialIssued,
      };
    } else {
      return {
        id: item.id,
        partId: item.part_id,
        PN: item.part_number || "--",
        SN: item.serial_number || "--",
        companyName: item.company_name || "--",
        Batch: item.batch_name || "N/A",
        QTY: (item.quantity || "0") + " " + item.uom_abrevation,
        [key]: value, // Propiedad dinámica
        "PN Description": item.part_description,
        status: item.status,
        type: item.type,
        uomName: item.uom_name,
        internalBatch: item.internal_batch,
        location_name: item.location_name,
        location_code: item.location_code,
        aircraft_name: item.aircraft_name,
        aircraft_id: item.aircraft_id,
        serializedPartId: item.serialized_part,
        orginalInfo: item,
        isPartialIssued: item.isPartialIssued,
      };
    }
  };

  const tagsMapper = {
    success: "Available",
    info: "Installed",
    warning: "Pending",
    issued: "Issued",
  };

  const closeSave = () => {
    setUpdateFromPartIssue(new Date());
  };

  const switchedTagsMapper = Object.fromEntries(
    Object.entries(tagsMapper).map(([key, value]) => [value, key])
  );

  let contexthighlightstyle =
    "background-color: var(--blue-500); border: solid 1px var(--green-25);";
  const dispatch = useDispatch();

  useEffect(() => {
    
    if (navigateBatch) {
      let bathcToCompare = null;
      if (navigateBatch.transactionType == "IN") {
        bathcToCompare = navigateBatch.originalBatch;
      } else {
        bathcToCompare = navigateBatch.destinationBatch;
      }
      const matchedItem = formattedItems.find(
        (item) => item.internalBatch === bathcToCompare
      );
      setNavigateBatch(null);
      if (matchedItem) {
        toggleOpenState(matchedItem.id);
      }
    }
  }, [navigateBatch]);

  useEffect(() => {
    setFormattedItems(
      partList?.map((item, index) => {
        let mappedItem = itemMapper?.(item) ?? item;
        return { ...mappedItem, id: index };
      }) ?? []
    );
  }, [partList]);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!setLoadingParts) requestNextPage();
    }
  };
  const closeAllOpenStates = () => {
    setOpenStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };

  const toggleOpenState = (aircraftId) => {
    closeAllOpenStates();
    setTimeout(() => {
      setOpenStates((prevState) => ({
        ...prevState,
        [aircraftId]: !openStates[aircraftId],
      }));
    }, 100);
  };

  const didMount = useRef(false);
  const getSortingOrder = (order) => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    setSortingOrder(order);
  };
  const getContextMenuOptions = (part) => {
    const options = {
      "parts-configuration": {
        label: "Part Configuration",
        icon: "icon-windows",
        callback: () => {
          dispatch(clearActiveTab());
          navigate("/secure/configuration/parts", {
            state: { dataFromInventoryManagement: part.PN },
          });
        },
      },
    };
     const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
    if (part.status === "Available") {
      options.update = {
        label: "Part Issue",
        icon: "icon-issue",
        callback: () =>
          axios
            .post(
              `${environment.getPartRequestInfoByPart}?partId=${part.partId}&batchId=${part.internalBatch}&page=0&pageSize=300&search=&orderBy=`,
              [
                {
                  columnName: "company_id",
                  value: companyIds,
                },
              ],
              {
                headers: { "Content-Type": "application/json" },
              }
            )
            .then((response) => {
              if (response.data.responseCode === 200) {
                openDialog({
                  component: InventoryManagementIssue,
                  props: {
                    data: response.data.load,
                    part,
                    close: closeDialog,
                    saveSuccess: () => closeSave(),
                  },
                });
              } else {
                warningMsg("Something went wrong");
              }
            })
            .catch(() => warningMsg("Something went wrong")),
      };
    }
    if (part.status === "Issued" || part.isPartialIssued) {
      options.update2 = {
        label: "Part Return",
        icon: "icon-return",
        callback: () =>
          axios
            .get(
              `${environment.getInventoryTransactionsIssues}?partId=${part.partId}&batchNumber=${part.internalBatch}`,
              {
                headers: { "Content-Type": "application/json" },
              }
            )
            .then((response) => {
              if (response.data.responseCode === 200) {
                openDialog({
                  component: InventoryManagementReturn,
                  props: {
                    data: response.data.load,
                    part,
                    close: closeDialog,
                    saveSuccess: () => closeSave(),
                  },
                });
              } else {
                warningMsg("Something went wrong");
              }
            })
            .catch(() => warningMsg("Something went wrong")),
      };
    }

    return options;
  };
  return (
    <>
            <div className="sorting-header">
        <div className="sorting-free-slot"> </div>
        <SortingHeader/>
        {/* <Sorting
          onOrderChange={getSortingOrder}
          showHeaderOrder={true}
          ignoreProperties={true}
          properties={{
            part_number: "PN",
            ...(tabIndex !== 2 && { serial_number: "SN" }),
            company_name: "Company",
            batch_name: "Batch",
            quantity: "QTY",
            location_name: "Location",
            part_description: "PN Description",
          }}
        ></Sorting> */}
      </div>
    <div className="inventory-list" ref={listRef} onScroll={handleScroll}>

      {loadingParts ? (
        // Mostrar esqueletos mientras carga
        Array.from({ length: 7 }).map((_, idx) => (
          <div key={idx} className="item-container-skeleton">
            <Skeleton
              style={{ borderRadius: "10px" }}
              height="1.68rem"
              width={40}
            />
            <div className="item-skeleton-content">
              <Skeleton height={20} width="80%" />
            </div>
            <Skeleton height={30} width="7rem" />
          </div>
        ))
      ) : formattedItems.length === 0 ? (
        <ResultsNotFound />
      ) : (
        formattedItems.map((item, idx) => (
          <React.Fragment key={`${item.id}-${idx}`}>
            <div
              className={`${openStates[item.id] ? "active-class-part" : ""}`}
            >
              <Item
                onClick={() => toggleOpenState(item.id)}
                contextMenuInfo={{
                  type: CONTEXT_TYPES.PART,
                  options: getContextMenuOptions,
                  highlightstyle: contexthighlightstyle,
                }}
                hideLabels={true}
                lightFont={true}
                item={item}
                itemPrefix={PartImage}
                itemSuffix={({ item }) => (
                  <Tag
                    style={{ width: "9vw" }}
                    tag={item.status}
                    type={switchedTagsMapper[item.status]}
                    partiallIssued={item.isPartialIssued}
                  ></Tag>
                )}
                ignoreProperties={[
                  "id",
                  "status",
                  "type",
                  "partId",
                  "uomName",
                  "internalBatch",
                  "location_name",
                  "aircraft_name",
                  "serializedPartId",
                  "location_code",
                  "aircraft_id",
                  "orginalInfo",
                  "isPartialIssued",
                ]}
              />
            </div>
            {openStates[item.id] && (
              <PartDetails item={item} open={openStates[item.id]} />
            )}
          </React.Fragment>
        ))
      )}
    </div>
    </>
  );
};
